import Link from 'next/link';
import Router, { useRouter } from 'next/router';
import NProgress from 'nprogress';
import { logout } from '../../utils/auth';

Router.events.on('routeChangeStart', url => NProgress.start());
Router.events.on('routeChangeComplete', () => NProgress.done());
Router.events.on('routeChangeError', () => NProgress.done());

function asideMenu({ menu }) {
	const router = useRouter();
	const isActive = route => (router.asPath === route ? 'is-active' : '');

	return (
		<aside className="menu">
			{menu.map(({ name, elements }, index) => (
				<div key={index}>
					<p className="menu-label"> {name} </p>
					<ul className="menu-list">
						{elements.map(({ name, link }, i) => (
							<li key={i}>
								<Link href={link}>
									<a className={isActive(link)}>{name}</a>
								</Link>
							</li>
						))}
					</ul>
				</div>
			))}
			<div className="menu-label">
				<ul className="menu-list">
					<li>
						<a className="button is-danger" onClick={e => logout()}>
							Logout
						</a>
					</li>
				</ul>
			</div>
		</aside>
	);
}

export default asideMenu;
